<template>
  <section>
    <ServicesTopBar />
    <VendorServiceList />
    <SiteFooter />
  </section>
</template>

<script>
import ServicesTopBar from '../components/services/ServicesTopBar.vue'
import VendorServiceList from '../components/services/VendorServiceList.vue'
import SiteFooter from '../components/site/SiteFooter.vue';

export default {
  components: { ServicesTopBar, VendorServiceList, SiteFooter },
}
</script>

<style scoped>

</style>
